//#region Imports and Global Definitions
import React, { useState, useEffect, useCallback } from "react";
import {
  StyleSheet,
  View,
  SafeAreaView,
  ScrollView,
  Platform,
  SectionList,
  useWindowDimensions,
  Pressable,
  Image,
} from "react-native";
import { ActivityIndicator } from 'react-native-paper';
import { useTheme } from "@react-navigation/native";
import { createCommonStyles } from "../../../../styles/commonStyles";
import CustomLabel from "../../../../components/CustomLabel/CustomLabel";
import CustomButton from "../../../../components/CustomButton";
import { useAuthContext } from "../../../../hooks/useAuthContext";
import axios from "axios";
import { showMessage } from "react-native-flash-message";
import Ionicons from "@react-native-vector-icons/ionicons/static";
import CustomText from "../../../../components/CustomText/CustomText";
import { useAccountContext } from "../../../../hooks/useAccountContext";
import CustomDropDownWithIcons from "../../../../components/CustomDropDownWithIcons/CustomDropDownWithIcons";
import {
  Menu,
  MenuOptions,
  MenuOption,
  MenuTrigger,
  renderers,
} from "react-native-popup-menu";
import { useTranslation } from "react-i18next";
import * as ExpoDocumentPicker from "expo-document-picker";
import { DEFAULTPROFILE } from "../../../../img/DefaultProfile";

var _ = require("lodash");

const HRAdminAddNewDocument = ({ document = "", selectedCompany, onBack }) => {
  const { width, height } = useWindowDimensions();
  const isPlatformWeb = Platform.OS === "web" && width > 992 ? false : true;
  const { colors } = useTheme();
  const styles = makeStyles(colors, width, height, isPlatformWeb);
  const common = createCommonStyles(colors);
  const { user, clientApi } = useAuthContext();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const { account } = useAccountContext();
  const [isLoadingEmployees, setIsLoadingEmployees] = useState(false);
  const [location, setlocation] = useState([]);
  let location_options = [];
  const [locationOptions, setLocationOptions] = useState([]);
  const [employeesFound, setEmployeesFound] = useState(true);
  const [documents, setDocuments] = useState({});
  const [seniorityLevel, setSeniorityLevel] = useState([]);
  let senioritylevel_options = [];
  const [seniorityLevelOptions, setSeniorityLevelOptions] = useState([]);
  const [jobtitles, setJobTitles] = useState([]);
  let jobtitles_options = [];
  const [jobtitleOptions, setJobtitleOptions] = useState([]);
  const [department, setDepartment] = useState([]);
  let departments_options = [];
  const [departmentOptions, setDepartmentsOptions] = useState();
  const [employees, setemployees] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [employeeButtonStates, setEmployeeButtonStates] = useState({});
  const [employeesWithDocumentAccess, setEmployeesWithDocumentAccess] =
    useState([]);
  const [chooseAllEmployeesPressed, setChooseAllEmployeesPressed] =
    useState(false);
  const getAllEmployees = async (server_ip, token) => {
    try {
      var fetchCmd = server_ip + "api/Employee/DocumentEmployees";

      const response = await axios.get(fetchCmd, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          company: selectedCompany,
          locations: location.map((item) => `${item}`).toString(),
          depts: department.map((item) => `${item}`).toString(),
          seniorityLevels: seniorityLevel.map((item) => `${item}`).toString(),
          jobtitles: jobtitles.map((item) => `${item}`).toString(),
        },
      });
      console.log("DATA-->" + JSON.stringify(response.data));
      return response.data;
    } catch (error) {
      console.log(error);
      throw new Error(error);
    }
  };

  const getDepartments = async (server_ip, token) => {
    try {
      var fetchCmd = server_ip + "api/Company/Departments";
      const response = await axios.get(fetchCmd, {
        headers: { Authorization: `Bearer ${token}` },
        params: { company: `'${selectedCompany}'` },
      });
      return response.data;
    } catch (error) {
      console.log(error);
      throw new Error(error);
    }
  };

  const getSeniorityLevel = async (server_ip, token) => {
    try {
      var fetchCmd = server_ip + "api/Company/SeniorityLevels";
      const response = await axios.get(fetchCmd, {
        headers: { Authorization: `Bearer ${token}` },
        params: { company: `'${selectedCompany}'` },
      });
      return response.data;
    } catch (error) {
      console.log(error);
      throw new Error(error);
    }
  };

  const getJobTitles = async (server_ip, token) => {
    try {
      var fetchCmd = server_ip + "api/Company/JobTitles";
      const response = await axios.get(fetchCmd, {
        headers: { Authorization: `Bearer ${token}` },
        params: { company: `'${selectedCompany}'` },
      });
      return response.data;
    } catch (error) {
      console.log(error);
      throw new Error(error);
    }
  };

  const submitEmployeeDocuments = async (server_ip, token) => {
    let data = new FormData();
    let toBeRemovedEmpls = [];
    let toBeGivenAccess = [];
    // keep only the employees that we have removed their access on the doc
    toBeRemovedEmpls = employeesWithDocumentAccess.filter(
      (id) => !selectedEmployees.includes(id)
    );

    // remove the employees with existing doc access as to not give them access again
    toBeGivenAccess = selectedEmployees.filter(
      (id) => !employeesWithDocumentAccess.includes(id)
    );
    data.append("employeeID", account.employeeId);
    data.append(
      "fileName",
      document
        ? `${document.name}.${document.type}`
        : documents.file0.name.toString()
    );
    data.append(
      "hex",
      !document
        ? documents.file0.hex
        : base64ToHex(document.uri.split(";base64,")[1])
    );
    data.append("selectedEmployees", toBeGivenAccess);
    data.append("isEdit", document ? true : false);
    data.append("employeesToRemoveAccessFrom", toBeRemovedEmpls);
    data.append("companyRowGuid", document ? document.rowguid : "");
    data.append("company", document ? "" : selectedCompany);

    axios({
      method: "post",
      url: `${clientApi}api/Company/Submit`,
      data: data,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${user.token}`,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          showMessage({
            message: t("common:succDocs"),
            type: "success",
          });
        } else {
          showMessage({
            message: "Document Submission Was Not Successful",
            type: "danger",
            duration: 10000,
          });
        }
      })
      .catch((error) => { });
  };

  const getLocations = async (server_ip, token) => {
    try {
      var fetchCmd = server_ip + "api/Company/Locations";
      const response = await axios.get(fetchCmd, {
        headers: { Authorization: `Bearer ${token}` },
        params: { company: `'${selectedCompany}'` },
      });
      return response.data;
    } catch (error) {
      console.log(error);
      throw new Error(error);
    }
  };

  const getEmployeesWithDocumentAccess = async (server_ip, token) => {
    try {
      var fetchCmd = server_ip + "api/Employee/EmployeesDocumentAccess";
      const response = await axios.get(fetchCmd, {
        headers: { Authorization: `Bearer ${token}` },
        params: { documentRowguid: document.rowguid },
      });
      return response.data;
    } catch (error) {
      console.log(error);
      throw new Error(error);
    }
  };

  useEffect(() => {
    if (document) {
      getEmployeesWithDocumentAccess(clientApi, user.token).then(
        (employeesInDoc) => {
          setEmployeesWithDocumentAccess(
            employeesInDoc.map((employee) => employee.employeeID)
          );
          setemployees([...groupDataByLetter(employeesInDoc)]);
          let initialEmployeeButtonStates = {};
          let emplsInDoc = [];
          employeesInDoc.forEach((employee) => {
            initialEmployeeButtonStates[employee.employeeID] = true;
            emplsInDoc.push(employee.employeeID);
          });
          pickDocument();
          setSelectedEmployees([...selectedEmployees, ...emplsInDoc]);
          setEmployeeButtonStates(initialEmployeeButtonStates);
        }
      );
    }
  }, []);

  useEffect(() => {
    try {
      refreshVariables();

      setDepartmentsOptions([]);
      setDepartment([]);
      departments_options = [];
      setLocationOptions([]);
      location_options = [];
      setlocation([]);
      setSeniorityLevelOptions([]);
      senioritylevel_options = [];
      setSeniorityLevel([]);
      setJobtitleOptions([]);
      jobtitles_options = [];
      setJobTitles([]);

      setIsLoading(true);

      getDepartments(clientApi, user.token)
        .then((data) => {
          data.forEach((obj) => {
            departments_options.push({
              label: obj.description,
              value: obj.dept,
            });
          });
          setDepartmentsOptions(departments_options);

          // Get Locations
          getLocations(clientApi, user.token)
            .then((data) => {
              data.forEach((obj) => {
                location_options.push({
                  label: obj.description,
                  value: obj.location,
                });
              });
              setLocationOptions(location_options);

              // Get Seniority Level
              getSeniorityLevel(clientApi, user.token)
                .then((data) => {
                  data.forEach((obj) => {
                    senioritylevel_options.push({
                      label: obj.description,
                      value: obj.hcode,
                    });
                  });
                  setSeniorityLevelOptions(senioritylevel_options);

                  // Get Job Titles
                  getJobTitles(clientApi, user.token)
                    .then((data) => {
                      data.forEach((obj) => {
                        jobtitles_options.push({
                          label: obj.description,
                          value: obj.jobtitle,
                        });
                      });
                      setJobtitleOptions(jobtitles_options);
                      setIsLoading(false);
                    })
                    .catch((err) => {
                      console.log(err.message);
                      setIsLoading(false);
                    });
                })
                .catch((err) => {
                  console.log(err.message);
                  setIsLoading(false);
                });
            })
            .catch((err) => {
              console.log(err.message);
              setIsLoading(false);
            });
        })
        .catch((err) => {
          console.log(err.message);
          setIsLoading(false);
        });
    } catch {
      setIsLoading(false);
    }
  }, [selectedCompany]);

  const refreshVariables = () => {
    setChooseAllEmployeesPressed(false);
    setemployees([]);
    setSelectedEmployees([]);
    setEmployeeButtonStates([]);
    setDocuments({});
  };

  const groupDataByLetter = (data) => {
    //console.log(JSON.stringify(data))
    const safeData = Array.isArray(data) ? data : [];
    const grouped = safeData.reduce((acc, item) => {
      const firstletter = item.name[0].toUpperCase();
      if (!acc[firstletter]) acc[firstletter] = [];
      acc[firstletter].push(item);
      return acc;
    }, {});

    return Object.keys(grouped)
      .sort()
      .map((letter) => ({
        title: letter,
        data: grouped[letter],
      }));
  };

  function base64ToHex(str) {
    const raw = atob(str);
    let result = "";
    for (let i = 0; i < raw.length; i++) {
      const hex = raw.charCodeAt(i).toString(16);
      result += hex.length === 2 ? hex : "0" + hex;
    }
    return result.toUpperCase();
  }

  const pickDocument = useCallback(async () => {
    const maxSize = 30 * 1048576;
    let uri = null;
    let hex = null;
    let result = null;
    let type = null;
    try {
      let files = [];
      if (!document) {
        result = await ExpoDocumentPicker.getDocumentAsync({
          type: [
            "image/jpeg",
            "image/gif",
            "image/png",
            "application/pdf",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          ],
          copyToCacheDirectory: false,
          multiple: false,
        });
        if (result.output !== null) {
          files = Array.from(result.output);
          type = result.assets[0].mimeType;
          uri = result.assets[0].uri.split(";base64,")[1];
          hex = base64ToHex(uri.toString());
        }
      } else {
        files = [document];
        uri = document.uri.split(";base64,")[1];
        hex = base64ToHex(uri.toString());
      }
      let docs = {};
      files.map((file) => {
        if (document || file.size < maxSize) {
          file["hex"] = hex;
          docs[`file${Object.keys(docs).length}`] = file;
          file["uri"] = uri;
          file["name"] = file.name;
        } else {
          showMessage({
            message: t("common:selectAttach"),
            type: "warning",
            duration: 3000,
          });
        }
      });
      setDocuments(docs);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const CreateDivider = () => {
    return (
      <View
        style={{
          borderBottomColor: "#000000",
          borderBottomWidth: StyleSheet.hairlineWidth,
        }}
      />
    );
  };

  const removeAttachment = () => {
    setDocuments({});
  };

  const handleEmployees = () => {
    setIsLoadingEmployees(true);
    if (chooseAllEmployeesPressed)
      setChooseAllEmployeesPressed(!chooseAllEmployeesPressed);

    getAllEmployees(clientApi, user.token)
      .then((data) => {
        console.log("Data" + JSON.stringify(data));
        if (data.length === 0) {
          setEmployeesFound(false); // No employees found
        } else {
          setEmployeesFound(true);
          setemployees(groupDataByLetter(data));
          const initialEmployeeButtonStates = {};
          data.forEach((employee) => {
            initialEmployeeButtonStates[employee.employeeID] = false;
          });
          employeesWithDocumentAccess.forEach((id) => {
            initialEmployeeButtonStates[id] = true;
          });
          setEmployeeButtonStates(initialEmployeeButtonStates);
        }
        setIsLoadingEmployees(false);
      })
      .catch((err) => {
        console.log(err.message);
        setIsLoadingEmployees(false);
      });
  };

  const createNewDocument = () => {
    let toBeRemovedEmpls = employeesWithDocumentAccess.filter(
      (id) => !selectedEmployees.includes(id)
    );

    if (selectedEmployees.length === 0 && toBeRemovedEmpls.length === 0) {
      showMessage({
        message: t("common:chooseAnEmplMessage"),
        type: "error",
      });
    } else if (documents === undefined || Object.keys(documents).length === 0) {
      showMessage({
        message: t("common:chooseADocMessage"),
        type: "error",
      });
    } else {
      submitEmployeeDocuments(clientApi, user.token)
        .then((data) => {
          refreshVariables();
        })
        .catch((err) => {
          console.log(err.message);
        });
    }
  };

  const handleToggle = (employee) => {
    if (selectedEmployees.includes(employee.employeeID)) {
      setSelectedEmployees(
        selectedEmployees.filter((id) => id !== employee.employeeID)
      );
    } else {
      setSelectedEmployees((prevState) => [...prevState, employee.employeeID]);
    }
    setEmployeeButtonStates((prevState) => ({
      ...prevState,
      [employee.employeeID]: !prevState[employee.employeeID],
    }));
  };

  const chooseAllEmployees = () => {
    if (employees.length === 0) {
      showMessage({
        message: t("common:findEmplMessage"),
        type: "error",
      });
    } else {
      if (!chooseAllEmployeesPressed) {
        const ids = employees
          .map((item) => item.data.map((item) => item.employeeID))
          .flat();
        setSelectedEmployees([...ids]);
        let initialEmployeeButtonStates = {};
        ids.forEach((id) => {
          initialEmployeeButtonStates[id] = true;
        });
        setEmployeeButtonStates(initialEmployeeButtonStates);
      } else {
        setEmployeeButtonStates({});
        setSelectedEmployees([]);
      }
      setChooseAllEmployeesPressed(!chooseAllEmployeesPressed);
    }
  };

  const openDocument = (file) => {
    const newWindow = window.open("", "_blank");
    let uri = file.uri;
    let style = 'width="100%" height="100%"';
    if (!uri.includes("base64")) {
      uri = `data:${file.type};base64,${uri}`;
    }
    if (
      file.type.includes("image") ||
      file.type.includes("jpg") ||
      file.type.includes("png")
    )
      style = 'width="500" height="500"';
    newWindow.document.write(
      `<html> <body> <embed src="${uri}" ${style} /> </body> </html>`
    );
  };

  const showDocuments = () => {
    return (
      <View>
        {Object.entries(documents).map(([key, value]) => (
          <View key={key} style={styles.documentContainer}>
            <View style={styles.documentIcons}>
              <Ionicons name="document-outline" style={styles.icons} />
            </View>
            <View style={styles.attachmentNameContainer}>
              <CustomText style={styles.attachmentNameText}>
                {value.name}
              </CustomText>
            </View>
            <View style={styles.documentIcons}>
              <Menu
                renderer={renderers.SlideInMenu}
                style={styles.attachmentMenu}
              >
                <MenuTrigger>
                  <Ionicons name="ellipsis-vertical" style={styles.dotsIcon} />
                </MenuTrigger>
                <MenuOptions customStyles={optionsStyles}>
                  {CreateDivider()}
                  {!document ? (
                    <MenuOption
                      onSelect={() => removeAttachment(key)}
                      customStyles={removeOptionStyles}
                      text={t("common:remove")}
                    ></MenuOption>
                  ) : (
                    <></>
                  )}
                  {CreateDivider()}
                  <MenuOption
                    onSelect={() => openDocument(value)}
                    customStyles={openOptionStyles}
                    text={t("common:open")}
                  ></MenuOption>
                  {CreateDivider()}
                  <MenuOption
                    customStyles={cancelOptionStyles}
                    text={t("common:cancel")}
                  ></MenuOption>
                </MenuOptions>
              </Menu>
            </View>
          </View>
        ))}
      </View>
    );
  };

  if (isLoading) {
    return (
      <View style={styles.loader}>
        <ActivityIndicator animating={true} color={colors.blue} />
      </View>
    );
  }

  return (
    <SafeAreaView style={styles.mainView}>
      <SafeAreaView style={styles.subMain}>
        <ScrollView>
          {/* Choose Document Section */}
          <SafeAreaView>
            <SafeAreaView style={styles.row}>
              <View style={{}}>
                <CustomLabel
                  value={t("common:chooseDocument")}
                  type="NEW_DOCUMENT"
                />
                <Pressable style={styles.row} onPress={pickDocument}>
                  <View style={styles.customIconContainerPaperclip}>
                    <Ionicons
                      name="document"
                      style={styles.paperClipIcon}
                    ></Ionicons>
                  </View>
                  <View
                    style={
                      Object.keys(documents).length !== 0
                        ? styles.documentExistView
                        : styles.documentNotExistView
                    }
                  >
                    {Object.keys(documents).length !== 0 ? (
                      showDocuments()
                    ) : (
                      <CustomLabel
                        type="NEW_REQUEST_NO_ATTACHMENTS"
                        value={t("common:selectAttach")}
                      />
                    )}
                  </View>
                </Pressable>
              </View>
              <View style={{ marginLeft: "auto" }}>
                <CustomButton
                  onPress={() => {
                    if (onBack) onBack();
                  }}
                  iconName="chevron-back-circle-outline"
                  show="NEW_DOCUMENT"
                  type="NEW_DOCUMENT"
                  textTop="0"
                  sz={40}
                />
              </View>
            </SafeAreaView>
          </SafeAreaView>

          <View style={styles.horizontalLine} />

          {/* Choose Employees Section */}
          <SafeAreaView style={[styles.row, { height: "100%" }]}>
            <View style={{ width: "30%", flex: 1 }}>
              <View style={{ zIndex: 4, width: "80%", flex: 1 }}>
                <CustomLabel
                  value={t("common:department")}
                  type="NEW_DOCUMENT"
                />
                <CustomDropDownWithIcons
                  defValue={department}
                  options={departmentOptions}
                  setValue={setDepartment}
                  multiple={true}
                  type="NEW_DOCUMENT"
                />
              </View>
              <View style={{ zIndex: 3, width: "80%", flex: 1, marginTop: 10 }}>
                <CustomLabel value={t("common:jobTitle")} type="NEW_DOCUMENT" />
                <CustomDropDownWithIcons
                  defValue={jobtitles}
                  options={jobtitleOptions}
                  setValue={setJobTitles}
                  multiple={true}
                  type="NEW_DOCUMENT"
                />
              </View>
              <View style={{ zIndex: 2, width: "80%", flex: 1, marginTop: 10 }}>
                <CustomLabel value={t("common:location")} type="NEW_DOCUMENT" />
                <CustomDropDownWithIcons
                  defValue={location}
                  options={locationOptions}
                  setValue={setlocation}
                  multiple={true}
                  type="NEW_DOCUMENT"
                />
              </View>
              <View style={{ zIndex: 1, width: "80%", flex: 1, marginTop: 10 }}>
                <CustomLabel
                  value={t("common:seniorityLevel")}
                  type="NEW_DOCUMENT"
                />
                <CustomDropDownWithIcons
                  defValue={seniorityLevel}
                  options={seniorityLevelOptions}
                  setValue={setSeniorityLevel}
                  multiple={true}
                  type="NEW_DOCUMENT"
                />
              </View>
              <SafeAreaView style={[styles.row]}>
                <CustomButton
                  text={t("common:findEmployees")}
                  onPress={() => {
                    handleEmployees();
                  }}
                  type="BUTTON_ADD"
                  textTop="0"
                  sz={20}
                />
                <CustomButton
                  text={
                    !chooseAllEmployeesPressed
                      ? t("common:chooseAllEmployees")
                      : t("common:removeAllEmployees")
                  }
                  onPress={() => {
                    chooseAllEmployees();
                  }}
                  type={
                    !chooseAllEmployeesPressed
                      ? "BUTTON_ADD"
                      : "BUTTON_CANCEL"
                  }
                  textTop="0"
                  sz={20}
                />
                <CustomButton
                  text={t("common:submit")}
                  onPress={() => {
                    createNewDocument();
                  }}
                  type='BUTTON_SAVE'
                  isGradient={true}
                  textTop='0'
                  sz={15}
                />
              </SafeAreaView>
            </View>
            <SafeAreaView style={[common.cardstyle]}>
              {isLoadingEmployees ? (
                <View style={styles.loader}>
                  <ActivityIndicator animating={true} color={colors.blue} />
                </View>
              ) : (
                employees.length > 0 ? (
                  <SectionList
                    sections={employees}
                    keyExtractor={(item, index) => item.employeeID}
                    initialNumToRender={30}
                    contentContainerStyle={{
                      paddingHorizontal: 10,
                      maxHeight: height * 0.5,
                    }}
                    renderItem={({ item }) => (
                      <View style={[styles.item, { flexDirection: "row" }]}>
                        <Pressable
                          onPress={() => handleToggle(item)}
                          style={[
                            employeeButtonStates[item.employeeID] === true
                              ? styles.Button_SELECTED
                              : null,
                            { flexDirection: "row", alignItems: "center" }, // Add flexDirection and alignItems here
                          ]}
                        >
                          <Image
                            style={{
                              width: Platform.OS === "web" ? 50 : 30,
                              height: Platform.OS === "web" ? 50 : 30,
                              marginRight: 10,
                              borderRadius: 100,
                              borderWidth: 1,
                              justifyContent: "center",
                              marginLeft: "2%",
                              marginBottom: "1%",
                            }}
                            source={{
                              uri: `data:image/png;base64,${item.photograph || DEFAULTPROFILE
                                }`,
                            }}
                          />
                          <CustomLabel value={item.name} type="MAJOR" />
                        </Pressable>
                      </View>
                    )}
                    renderSectionHeader={({ section: { title } }) => (
                      <CustomLabel value={title} type="MAJOR" />
                    )}
                  />
                ) : (
                  !employeesFound && (
                    <SafeAreaView style={styles.noUsersFound}>
                      <CustomLabel
                        value={t("common:nouserswerefound")}
                        type="ASSM" />
                    </SafeAreaView>
                  )
                )
              )}
            </SafeAreaView>
          </SafeAreaView>
        </ScrollView>
      </SafeAreaView>
    </SafeAreaView>
  );
};

//#region Styles
const makeStyles = (colors, isPlatformWeb) =>
  StyleSheet.create({
    mainView: {
      flex: 1,
      marginLeft: "2%",
    },
    subMain: {
      flex: 1,
    },
    pressedButton: {
      backgroundColor: "red",
    },
    container: {
      flex: 1,
      justifyContent: "center",
      alignItems: "center",
    },
    scroll: {
      flex: 1,
      width: "100%",
      height: "100%",
    },
    row: {
      flex: 1,
      flexDirection: "row",
    },
    item: {
      borderColor: "green",
    },
    cardstyle: {
      flex: 1,
      margin: "1%",
      borderRadius: 5,
      elevation: 5,
      shadowColor: colors.card_line,
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.3,
      shadowRadius: 5,
      backgroundColor: Platform.OS === "web" ? colors.background_card : "#FFF",
      width: "65%",
    },
    horizontalLine: {
      backgroundColor: colors.buttons_primary,
      height: 1,
      marginVertical: "2%",
      marginRight: "1%"
    },
    paperClipIcon: {
      fontSize: 22,
      color: colors.text_primary,
    },
    documentContainer: {
      flexDirection: "row",
      borderRadius: 10,
      borderColor: "green",
      marginHorizontal: "3%",
      marginVertical: "1%",
      justifyContent: "center",
      alignItems: "center",
    },
    documentIcons: {
      flex: 0.7,
      alignItems: "flex-start",
      color: colors.text_primary,
    },
    attachmentNameContainer: {
      flex: 7,
      alignItems: "flex-start",
    },
    attachmentNameText: {
      fontSize: 16,
      color: colors.text_primary,
    },
    attachmentMenu: {
      alignSelf: "flex-end",
    },
    Button_SELECTED: {
      borderWidth: 4,
      borderColor: "#86BC25",
      elevation: 5,
      shadowColor: colors.card_line,
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.3,
      shadowRadius: 5,
      width: "75%",
    },
    customIconContainerPaperclip: {
      width: "10%",
      marginTop: 3,
    },
    documentExistView: {
      width: "100%",
      backgroundColor: colors.background_card,
      marginHorizontal: "3%",
      marginVertical: isPlatformWeb ? 5 : 0,
      paddingVertical: isPlatformWeb ? 0 : 3,
      marginBottom: "-1%",
    },
    documentNotExistView: {
      width: "100%",
      backgroundColor: colors.background_card,
      marginHorizontal: "3%",
      marginVertical: isPlatformWeb ? 5 : 0,
      paddingVertical: isPlatformWeb ? 0 : 3,
      marginBottom: "-1%",
    },
    loader: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: '4%'
    },
    noUsersFound: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: '4%',
    },
  });
const optionsStyles = {
  optionsContainer: {
    marginHorizontal: "3.5%",
    marginVertical: "-3%",
    borderRadius: 10,
  },
  optionWrapper: {
    height: 50,
    justifyContent: "center",
  },
};

const openOptionStyles = {
  optionText: {
    textAlign: "center",
    fontSize: 16,
    fontWeight: "bold",
  },
};

const removeOptionStyles = {
  optionText: {
    textAlign: "center",
    fontSize: 16,
    color: "#dd3636",
  },
};

const cancelOptionStyles = {
  optionText: {
    textAlign: "center",
    fontSize: 16,
  },
};

//#endregion

export default HRAdminAddNewDocument;
